
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'epidural_anaesthesia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/epidural_anaesthesia.vue